export enum SearchType {
  NEW,
  QUICK,
  RECENT,
  DEFAULT = '',
}
